import { AbstractControl, ValidationErrors } from '@angular/forms';

const isAddressValid = (address): boolean => {
    return !!address?.id;
};

export const AddressValidators = {
    required: (control: AbstractControl): ValidationErrors | null =>
        !control.value || isAddressValid(control.value) ? null : { addressRequired: true },

    /**
     * Check that postal code is in metropolitan (not Guadeloupe, Martinique ...)
     */
    metropolitan: (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const isPostalCodeValid = value?.postalCode && !RegExp('^(97|98)[0-9]{3}$').test(value.postalCode);

        return isPostalCodeValid ? null : { addressMetropolitanInvalid: true };
    },

    /**
     * Check that specified address is complete i.e. there is a street, a street number or there is only one house in the street
     */
    complete: (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const isStreetNumberValid =
            value?.streetNumber ||
            (!value?.street?.minStreetNumber && !value?.street?.maxStreetNumber) ||
            parseInt(value?.street?.maxStreetNumber) - parseInt(value?.street?.minStreetNumber) === 0;

        return value?.street && isStreetNumberValid ? null : { addressCompleteInvalid: true };
    },
};
